//  import './App.css'
import { useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";

// Swiper styles
// import "swiper/css";
// import "swiper/css/navigation"; s
// import "swiper/css/pagination";

import { adminUrl } from '../components/urls';
import { fetchGet } from '../fetchData/fetchGet';

export const ShopOwner = () => {
    const [ShopInfo, setShopInfo] = useState({});
    const [AllShopInfo, setAllShopInfo] = useState([]);
    const [isLogedIn, setLogedin] = useState(false);
    const [Customer, setCustomer] = useState({});
    const [selectedPlan, setSelectedPlan] = useState(null);

    const plans = [
        {
            id: "monthly",
            title: "Monthly",
            price: "$20",
            subtext: "Per month",
            billed: "Billed monthly",
        },
        {
            id: "sixmonth",
            title: "6 Months",
            price: "$18",
            subtext: "Per month",
            billed: "Billed every 6 months ($108 total)",
        },
        {
            id: "yearly",
            title: "1 Year",
            price: "$15",
            subtext: "Per month",
            billed: "Billed yearly ($180 total)",
            popular: true,
        }
    ];

    useEffect(() => {
        document.title = ShopInfo?.ShopName ?? 'Alarzmall';
        const fetchData = async () => {
            try {
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/svg+xml';
                link.rel = 'icon';
                link.href = '/src/assets/images/logo-dark.png';
                if (!document.querySelector("link[rel*='icon']")) {
                    document.head.appendChild(link);
                }
            } catch (error) {
                console.error('Error fetching Brands:', error);
            }
        };
        fetchData();
    }, [ShopInfo]);

    const getQueryParam = (param) => {
        const params = new URLSearchParams(window.location.search);
        return params.get(param);
    };
    // const Shop = getQueryParam('Shop') ?? null;
    const [Shop, setShop] = useState('');

    // let secretKey = 'ShopIDArzMall';
    // var decrypted = Shop ? CryptoJS.AES.decrypt(Shop, secretKey).toString(CryptoJS.enc.Utf8) : '';
    // var Rlv3 = decrypted / 2016;
    // var Rlv2 = Rlv3 / 9;
    // var Rlv1 = Rlv2 / 24;
    localStorage.setItem('sss', Shop);

    useEffect(() => {
        const fetcheJWT = async (Rlv1) => {
            try {
                const jwts = await JWT(Rlv1);
                if (jwts && jwts.state) {
                    setLogedin(jwts.state);
                    setCustomer(jwts);
                } else if (jwts?.newJWT && Shop) {
                    setTimeout(() => {
                        window.location.href = '/';
                    }, 100);
                } else {
                    console.error('Unexpected response format:');
                }
            } catch (err) {
                console.error('Failed to fetch JWT: ' + err);
            }
        };
        fetcheJWT(Shop);
        const fetch = async () => {
            try {
                const data = await fetchGet('VwShop');
                setShopInfo(data[0]);
                if (data && data.length < 1) {
                    const AllShopsdata = await fetchGet('VwShop', true);
                    setAllShopInfo(AllShopsdata);
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetch();
    }, [Shop]);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        shopName: ""
    });

    const handleRegister = (e) => {
        e.preventDefault();
        // Handle your registration API logic here
        alert("Registration submitted!");
    };
    return (
        <div className="min-h-screen w-full flex flex-col items-center justify-center bg-gray-50 p-6">


            {/* // <div className="min-h-screen bg-gray-50  flex flex-col items-center"> */}


            {/* Top Section */}
            <div className="w-full items-center justify-center ">
                <h1 className="text-3xl font-semibold text-gray-800 text-center">
                    Become a Shop Owner
                </h1>

                <p className="text-gray-500 text-center mt-2">
                    Register your shop below or access your admin dashboard.
                </p>

                {/* Form + Admin */}
                <div className="mt-4 flex flex-col md:flex-row gap-6 justify-center">

                    {/* Registration Form */}
                    {selectedPlan &&
                        <form
                            className="bg-white shadow-md rounded-2xl p-6 w-full md:w-1/2 border border-gray-100"
                            onSubmit={handleRegister}
                        >
                            <h2 className="text-xl font-semibold text-gray-800 mb-4">
                                Register Your Shop
                            </h2>

                            <div className="grid grid-cols-1 gap-4">
                                <input
                                    type="text"
                                    placeholder="Your Full Name"
                                    className="p-3 border rounded-lg"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                    required
                                />

                                <input
                                    type="email"
                                    placeholder="Email"
                                    className="p-3 border rounded-lg"
                                    value={formData.email}
                                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                    required
                                />

                                <input
                                    type="tel"
                                    placeholder="Phone Number"
                                    className="p-3 border rounded-lg"
                                    value={formData.phone}
                                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                    required
                                />

                                <input
                                    type="text"
                                    placeholder="Desired Shop Name"
                                    className="p-3 border rounded-lg"
                                    value={formData.shopName}
                                    onChange={(e) => setFormData({ ...formData, shopName: e.target.value })}
                                    required
                                />
                            </div>

                            <button
                                type="submit"
                                className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl transition-all"
                            >
                                Register Shop
                            </button>
                        </form>
                    }

                    {/* Already A Shop Owner */}
                    <div className="bg-white shadow-md rounded-2xl p-8 w-full items-center flex flex-col justify-center border border-gray-100">
                        <div className="w-full max-w-5xl mt-12">
                            <h2 className="text-2xl font-semibold text-gray-800 text-center mb-6">
                                Choose Your Plan
                            </h2>

                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                {plans.map((plan) => (
                                    <div
                                        key={plan.id}
                                        className={`
        p-6 rounded-2xl border transition-all cursor-pointer flex flex-col
        ${selectedPlan === plan.id
                                                ? "border-blue-600 shadow-xl"
                                                : "border-gray-200 shadow-md hover:shadow-lg"
                                            }
        bg-white relative
      `}
                                        onClick={() => setSelectedPlan(plan.id)}
                                    >
                                        {/* Recommended Tag */}
                                        {plan.popular && (
                                            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs py-1 px-3 rounded-full shadow">
                                                Most Popular
                                            </div>
                                        )}

                                        <h3 className="text-xl font-semibold text-gray-800">{plan.title}</h3>

                                        <div className="mt-4 text-4xl font-bold text-gray-800">
                                            {plan.price}
                                            <span className="text-lg text-gray-500">/mo</span>
                                        </div>

                                        <p className="text-gray-500 text-sm mt-2">{plan.billed}</p>

                                        {/* BUTTON FIXED AT BOTTOM */}
                                        <button
                                            className={`
          mt-auto w-full py-2 rounded-xl text-white transition-all
          ${selectedPlan === plan.id
                                                    ? "bg-blue-600"
                                                    : "bg-gray-800 hover:bg-gray-900"
                                                }
        `}
                                        >
                                            {selectedPlan === plan.id ? "Selected" : "Choose Plan"}
                                        </button>
                                    </div>
                                ))}
                            </div>

                        </div>

                        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-2">
                            Already a Shop Owner?
                        </h2>
                        <p className="text-gray-500 mb-4">
                            Access your shop dashboard here.
                        </p>

                        <a
                            href="https://admin.alarzmall.com/"
                            target="_blank"
                            className="bg-black-600 hover:bg-black-700 text-red py-3 rounded-xl text-center transition-all"
                        >
                            Go to Shop Admin Panel
                        </a>
                    </div>
                </div>
            </div>



            {/* Swiper Shops Slider */}
            {/* <div className="w-full max-w-6xl mt-6">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                        Explore Shops
                    </h2> */}

            {/* <Swiper
                            modules={[Navigation, Pagination, Autoplay]}
                            spaceBetween={20}
                            slidesPerView={1.1}
                            loop={true} // recommended for autoplay
                            navigation
                            pagination={{ clickable: true }}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false, // keep autoplay after user interacts
                                pauseOnMouseEnter: true,     // optional: pause on hover
                            }}
                            speed={600}
                            breakpoints={{
                                640: { slidesPerView: 2.1 },
                                1024: { slidesPerView: 3.1 },
                            }}
                            // fallback: force-start autoplay if it doesn't start automatically
                            onSwiper={(swiper) => {
                                // some environments (React StrictMode / hydration quirks) may need this
                                try {
                                    if (swiper && swiper.autoplay) swiper.autoplay.start();
                                } catch (err) {
                                    // no-op
                                }
                            }}
                        >



                            {AllShopInfo.map((shop) => {
                                let secretKey = "ShopIDArzMall";
                                let encrypted = CryptoJS.AES.encrypt(
                                    shop.ShopID.toString(),
                                    secretKey
                                ).toString();

                                return (
                                    <SwiperSlide key={shop.ShopID}>
                                        <div
                                            className="bg-white p-6 rounded-2xl shadow hover:shadow-xl cursor-pointer transition-all border border-gray-100"
                                            onClick={() => window.location.href = `/${shop.Nickname}`}
                                        >
                                            <img src={adminUrl + shop.Logo || '/src/assets/images/shop-placeholder.png'} alt={shop.ShopName} className="w-full h-40 object-contain mb-4" />
                                            <h3 className="text-xl font-semibold text-gray-800">
                                                {shop.ShopName}
                                            </h3>
                                            <div className="mt-4">
                                                <span className="inline-block bg-blue-100 text-blue-600 text-sm px-3 py-1 rounded-full">
                                                    View Shop
                                                </span>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper> */}
            {/* </div> */}
        </div>
    );
}

